export default [
    'g_branch_office.g_commune',
    'g_user',
    'acc_detail_ledgers.acc_account',
    'acc_detail_ledgers.acc_debits',
    'acc_detail_ledgers.acc_credits',
]
